IntlPolyfill.__addLocaleData({
  locale: 'ar',
  date: {
    ca: ['gregory'],
    hourNo0: !0,
    hour12: !0,
    formats: [
      {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        pattern: '{weekday}، {day} {month}، {year} {hour}:{minute}:{second}',
        pattern12:
          '{weekday}، {day} {month}، {year} {hour}:{minute}:{second} {ampm}',
      },
      {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        pattern: '{weekday}، {day} {month}، {year}',
      },
      {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day} {month}، {year} {hour}:{minute}',
        pattern12: '{day} {month}، {year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        pattern: '{day} {month}، {year} {hour}:{minute}',
        pattern12: '{day} {month}، {year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day} {month}، {year} {hour}:{minute}',
        pattern12: '{day} {month}، {year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        pattern: '{day} {month}، {year} {hour}:{minute}',
        pattern12: '{day} {month}، {year} {hour}:{minute} {ampm}',
      },
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        pattern: '{day}‏/{month}‏/{year} {hour}:{minute}',
        pattern12: '{day}‏/{month}‏/{year} {hour}:{minute} {ampm}',
      },
      {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        pattern: '{day} {month}، {year}',
      },
      {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        pattern: '{day} {month}، {year}',
      },
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        pattern: '{day}‏/{month}‏/{year}',
      },
      {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        pattern: '{day}‏/{month}‏/{year}',
      },
      { month: 'long', year: 'numeric', pattern: '{month} {year}' },
      { month: 'short', year: 'numeric', pattern: '{month} {year}' },
      { month: 'numeric', year: 'numeric', pattern: '{month}‏/{year}' },
      { day: 'numeric', month: 'long', pattern: '{day} {month}' },
      { day: 'numeric', month: 'short', pattern: '{day} {month}' },
      { day: 'numeric', month: 'numeric', pattern: '{day}/‏{month}' },
      {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        pattern: '{hour}:{minute}:{second}',
        pattern12: '{hour}:{minute}:{second} {ampm}',
      },
      {
        hour: 'numeric',
        minute: '2-digit',
        pattern: '{hour}:{minute}',
        pattern12: '{hour}:{minute} {ampm}',
      },
      { year: 'numeric', pattern: '{year}' },
      { year: '2-digit', pattern: '{year}' },
      { month: 'long', pattern: '{month}' },
      { month: 'short', pattern: '{month}' },
      { month: 'numeric', pattern: '{month}' },
      { weekday: 'long', pattern: '{weekday}' },
      { weekday: 'narrow', pattern: '{weekday}' },
      { weekday: 'short', pattern: '{weekday}' },
      { day: 'numeric', pattern: '{day}' },
    ],
    calendars: {
      gregory: {
        months: {
          narrow: ['ي', 'ف', 'م', 'أ', 'و', 'ن', 'ل', 'غ', 'س', 'ك', 'ب', 'د'],
          short: [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ],
          long: [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ],
        },
        days: {
          narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
          short: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
          long: [
            'الأحد',
            'الاثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
        },
        eras: {
          short: ['ق.م', 'م', 'ب.م'],
          long: ['قبل الميلاد', 'ميلادي', 'بعد الميلاد'],
        },
        dayPeriods: { am: 'ص', pm: 'م' },
      },
    },
  },
  number: {
    nu: ['arab', 'latn'],
    patterns: {
      decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
      currency: {
        positivePattern: '{currency} {number}',
        negativePattern: '-{currency} {number}',
      },
      percent: { positivePattern: '{number}%', negativePattern: '-{number}%' },
    },
    symbols: {
      arab: {
        decimal: '٫',
        group: '٬',
        nan: 'ليس رقم',
        percent: '٪',
        infinity: '∞',
      },
      latn: {
        decimal: '.',
        group: ',',
        nan: 'NaN',
        percent: '%',
        infinity: '∞',
      },
    },
    currencies: {
      AED: 'د.إ.‏',
      AUD: 'AU$',
      BHD: 'د.ب.‏',
      BRL: 'R$',
      CAD: 'CA$',
      CNY: 'ي.ص',
      DZD: 'د.ج.‏',
      EGP: 'ج.م.‏',
      EUR: '€',
      GBP: '£',
      HKD: 'HK$',
      IDR: 'ر.إن.',
      ILS: '₪',
      INR: 'ر.ه.‏',
      IQD: 'د.ع.‏',
      IRR: 'ر.إ.',
      JOD: 'د.أ.‏',
      JPY: 'JP¥',
      KMF: 'ف.ج.ق.‏',
      KRW: '₩',
      KWD: 'د.ك.‏',
      LBP: 'ل.ل.‏',
      LYD: 'د.ل.‏',
      MAD: 'د.م.‏',
      MRO: 'أ.م.‏',
      MXN: 'MX$',
      NZD: 'NZ$',
      OMR: 'ر.ع.‏',
      PKR: 'ر.ب.',
      QAR: 'ر.ق.‏',
      SAR: 'ر.س.‏',
      SDD: 'د.س.‏',
      SDG: 'ج.س.',
      SSP: 'ج.ج.س.',
      SYP: 'ل.س.‏',
      THB: '฿',
      TND: 'د.ت.‏',
      TRY: 'ل.ت.',
      TWD: 'NT$',
      USD: 'US$',
      VND: '₫',
      XAF: 'FCFA',
      XCD: 'EC$',
      XOF: 'CFA',
      XPF: 'CFPF',
      XXX: '***',
      YER: 'ر.ي.‏',
    },
  },
}),
  IntlPolyfill.__addLocaleData({
    locale: 'cs',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day}. {month}. {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day}. {month}. {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day}. {month}. {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}:{minute}',
          pattern12: '{day}. {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}:{minute}',
          pattern12: '{day}. {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month}. {year} {hour}:{minute}',
          pattern12: '{day}. {month}. {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day}. {month}. {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}. {month}. {year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}. {month}. {year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'short', pattern: '{day}. {month}.' },
        { day: 'numeric', month: 'numeric', pattern: '{day}. {month}.' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}.' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
            ],
            short: [
              'led',
              'úno',
              'bře',
              'dub',
              'kvě',
              'čvn',
              'čvc',
              'srp',
              'zář',
              'říj',
              'lis',
              'pro',
            ],
            long: [
              'ledna',
              'února',
              'března',
              'dubna',
              'května',
              'června',
              'července',
              'srpna',
              'září',
              'října',
              'listopadu',
              'prosince',
            ],
          },
          'months-stand-alone': {
            long: [
              'leden',
              'únor',
              'březen',
              'duben',
              'květen',
              'červen',
              'červenec',
              'srpen',
              'září',
              'říjen',
              'listopad',
              'prosinec',
            ],
          },
          days: {
            narrow: ['N', 'P', 'Ú', 'S', 'Č', 'P', 'S'],
            short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
            long: [
              'neděle',
              'pondělí',
              'úterý',
              'středa',
              'čtvrtek',
              'pátek',
              'sobota',
            ],
          },
          eras: {
            narrow: ['př.n.l.', 'n.l.', 'n. l.'],
            short: ['př. n. l.', 'n. l.'],
            long: ['př. n. l.', 'n. l.'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        CSK: 'Kčs',
        CZK: 'Kč',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        TWD: 'NT$',
        USD: 'US$',
        XAF: 'FCFA',
        XBB: 'EMU',
        XCD: 'EC$',
        XEU: 'ECU',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'da',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day}. {month} {year} {hour}.{minute}.{second}',
          pattern12:
            '{weekday} {day}. {month} {year} {hour}.{minute}.{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}.{minute}',
          pattern12: '{day}. {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}.{minute}',
          pattern12: '{day}. {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}.{minute}',
          pattern12: '{day}. {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year} {hour}.{minute}',
          pattern12: '{day}. {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'short', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}.{minute}.{second}',
          pattern12: '{hour}.{minute}.{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}.{minute}',
          pattern12: '{hour}.{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}.' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'jan.',
              'feb.',
              'mar.',
              'apr.',
              'maj',
              'jun.',
              'jul.',
              'aug.',
              'sep.',
              'okt.',
              'nov.',
              'dec.',
            ],
            long: [
              'januar',
              'februar',
              'marts',
              'april',
              'maj',
              'juni',
              'juli',
              'august',
              'september',
              'oktober',
              'november',
              'december',
            ],
          },
          'months-stand-alone': {
            short: [
              'jan',
              'feb',
              'mar',
              'apr',
              'maj',
              'jun',
              'jul',
              'aug',
              'sep',
              'okt',
              'nov',
              'dec',
            ],
          },
          days: {
            narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
            short: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
            long: [
              'søndag',
              'mandag',
              'tirsdag',
              'onsdag',
              'torsdag',
              'fredag',
              'lørdag',
            ],
          },
          eras: {
            narrow: ['fKr', 'eKr', 'fvt', 'vt'],
            short: ['f.Kr.', 'e.Kr.', 'f.v.t.', 'v.t.'],
            long: [
              'f.Kr.',
              'e.Kr.',
              'før vesterlandsk tidsregning',
              'vesterlandsk tidsregning',
            ],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        DKK: 'kr.',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'de',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {day}. {month} {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day}. {month} {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}:{minute}',
          pattern12: '{day}. {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}:{minute}',
          pattern12: '{day}. {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}:{minute}',
          pattern12: '{day}. {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}:{minute}',
          pattern12: '{day}. {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}.{year}' },
        { day: 'numeric', month: 'long', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'short', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}.{month}.' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'Jan.',
              'Feb.',
              'März',
              'Apr.',
              'Mai',
              'Juni',
              'Juli',
              'Aug.',
              'Sep.',
              'Okt.',
              'Nov.',
              'Dez.',
            ],
            long: [
              'Januar',
              'Februar',
              'März',
              'April',
              'Mai',
              'Juni',
              'Juli',
              'August',
              'September',
              'Oktober',
              'November',
              'Dezember',
            ],
          },
          'months-stand-alone': {
            short: [
              'Jan',
              'Feb',
              'Mär',
              'Apr',
              'Mai',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Okt',
              'Nov',
              'Dez',
            ],
          },
          days: {
            narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
            short: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
            long: [
              'Sonntag',
              'Montag',
              'Dienstag',
              'Mittwoch',
              'Donnerstag',
              'Freitag',
              'Samstag',
            ],
          },
          eras: {
            narrow: ['v. Chr.', 'n. Chr.', 'v. u. Z.', 'u. Z.'],
            short: ['v. Chr.', 'n. Chr.', 'v. u. Z.', 'u. Z.'],
            long: [
              'v. Chr.',
              'n. Chr.',
              'vor unserer Zeitrechnung',
              'unserer Zeitrechnung',
            ],
          },
          dayPeriods: { am: 'vorm.', pm: 'nachm.' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        ATS: 'öS',
        AUD: 'AU$',
        BGM: 'BGK',
        BGO: 'BGJ',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        DEM: 'DM',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'en',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {month} {day}, {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {month} {day}, {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          pattern: '{weekday}, {month} {day}, {year}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month} {day}, {year}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month} {day}, {year}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          pattern: '{month}/{day}/{year}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month}/{day}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { month: 'long', day: 'numeric', pattern: '{month} {day}' },
        { month: 'short', day: 'numeric', pattern: '{month} {day}' },
        { month: 'numeric', day: 'numeric', pattern: '{month}/{day}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            short: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
            ],
            long: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ],
          },
          days: {
            short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            long: [
              'Sunday',
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ],
          },
          eras: {
            narrow: ['B', 'A'],
            short: ['BC', 'AD', 'BCE', 'CE'],
            long: [
              'Before Christ',
              'Anno Domini',
              'Before Common Era',
              'Common Era',
            ],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'A$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'es',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern:
            '{weekday}, {day} de {month} de {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} de {month} de {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} de {month} de {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} de {month} de {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} de {month} de {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} de {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} de {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} de {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} de {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'E',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'ene.',
              'feb.',
              'mar.',
              'abr.',
              'may.',
              'jun.',
              'jul.',
              'ago.',
              'sept.',
              'oct.',
              'nov.',
              'dic.',
            ],
            long: [
              'enero',
              'febrero',
              'marzo',
              'abril',
              'mayo',
              'junio',
              'julio',
              'agosto',
              'septiembre',
              'octubre',
              'noviembre',
              'diciembre',
            ],
          },
          'months-stand-alone': {
            short: [
              'Ene.',
              'Feb.',
              'Mar.',
              'Abr.',
              'May.',
              'Jun.',
              'Jul.',
              'Ago.',
              'Sept.',
              'Oct.',
              'Nov.',
              'Dic.',
            ],
            long: [
              'Enero',
              'Febrero',
              'Marzo',
              'Abril',
              'Mayo',
              'Junio',
              'Julio',
              'Agosto',
              'Septiembre',
              'Octubre',
              'Noviembre',
              'Diciembre',
            ],
          },
          days: {
            narrow: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            short: ['dom.', 'lun.', 'mar.', 'mié.', 'jue.', 'vie.', 'sáb.'],
            long: [
              'domingo',
              'lunes',
              'martes',
              'miércoles',
              'jueves',
              'viernes',
              'sábado',
            ],
          },
          eras: {
            short: ['a. C.', 'd. C.', 'a. e. c.', 'e. c.'],
            long: ['antes de Cristo', 'anno Dómini', 'a. e. c.', 'e. c.'],
          },
          dayPeriods: { am: 'a. m.', pm: 'p. m.' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        CAD: 'CA$',
        ESP: '₧',
        EUR: '€',
        THB: '฿',
        USD: '$',
        VND: '₫',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'fr',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day} {month} {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day} {month} {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'janv.',
              'févr.',
              'mars',
              'avr.',
              'mai',
              'juin',
              'juil.',
              'août',
              'sept.',
              'oct.',
              'nov.',
              'déc.',
            ],
            long: [
              'janvier',
              'février',
              'mars',
              'avril',
              'mai',
              'juin',
              'juillet',
              'août',
              'septembre',
              'octobre',
              'novembre',
              'décembre',
            ],
          },
          'months-stand-alone': {
            short: [
              'Janv.',
              'Févr.',
              'Mars',
              'Avr.',
              'Mai',
              'Juin',
              'Juil.',
              'Août',
              'Sept.',
              'Oct.',
              'Nov.',
              'Déc.',
            ],
            long: [
              'Janvier',
              'Février',
              'Mars',
              'Avril',
              'Mai',
              'Juin',
              'Juillet',
              'Août',
              'Septembre',
              'Octobre',
              'Novembre',
              'Décembre',
            ],
          },
          days: {
            narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            short: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
            long: [
              'dimanche',
              'lundi',
              'mardi',
              'mercredi',
              'jeudi',
              'vendredi',
              'samedi',
            ],
          },
          eras: {
            narrow: ['av. J.-C.', 'ap. J.-C.', 'AEC', 'EC'],
            short: ['av. J.-C.', 'ap. J.-C.', 'AEC', 'EC'],
            long: ['avant Jésus-Christ', 'après Jésus-Christ', 'AEC', 'EC'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        ARS: '$AR',
        AUD: '$AU',
        BEF: 'FB',
        BMD: '$BM',
        BND: '$BN',
        BRL: 'R$',
        BSD: '$BS',
        BZD: '$BZ',
        CAD: '$CA',
        CLP: '$CL',
        COP: '$CO',
        CYP: '£CY',
        EUR: '€',
        FJD: '$FJ',
        FKP: '£FK',
        FRF: 'F',
        GBP: '£GB',
        GIP: '£GI',
        IEP: '£IE',
        ILP: '£IL',
        ILS: '₪',
        INR: '₹',
        ITL: '₤IT',
        KRW: '₩',
        LBP: '£LB',
        LSL: 'lLS',
        MAF: 'fMA',
        MGF: 'Fmg',
        MTP: '£MT',
        MXN: '$MX',
        NAD: '$NA',
        NZD: '$NZ',
        RHD: '$RH',
        SBD: '$SB',
        SGD: '$SG',
        SRD: '$SR',
        THB: '฿',
        TTD: '$TT',
        USD: '$US',
        UYU: '$UY',
        VND: '₫',
        WST: 'WS$',
        XAF: 'FCFA',
        XDR: 'DTS',
        XOF: 'CFA',
        XPF: 'FCFP',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'id',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {day} {month} {year} {hour}.{minute}.{second}',
          pattern12:
            '{weekday}, {day} {month} {year} {hour}.{minute}.{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}.{minute}',
          pattern12: '{day} {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}.{minute}',
          pattern12: '{day} {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}.{minute}',
          pattern12: '{day} {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}.{minute}',
          pattern12: '{day} {month} {year} {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}.{minute}',
          pattern12: '{day}/{month}/{year} {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}.{minute}.{second}',
          pattern12: '{hour}.{minute}.{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}.{minute}',
          pattern12: '{hour}.{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Agt',
              'Sep',
              'Okt',
              'Nov',
              'Des',
            ],
            long: [
              'Januari',
              'Februari',
              'Maret',
              'April',
              'Mei',
              'Juni',
              'Juli',
              'Agustus',
              'September',
              'Oktober',
              'November',
              'Desember',
            ],
          },
          days: {
            narrow: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
            short: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
            long: [
              'Minggu',
              'Senin',
              'Selasa',
              'Rabu',
              'Kamis',
              'Jumat',
              'Sabtu',
            ],
          },
          eras: {
            narrow: ['SM', 'M'],
            short: ['SM', 'M', 'SEU', 'EU'],
            long: ['Sebelum Masehi', 'M', 'Sebelum Era Umum', 'Era Umum'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        IDR: 'Rp',
        ILS: '₪',
        INR: 'Rs',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        UYU: '$U',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'it',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day} {month} {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day} {month} {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year}, {hour}:{minute}',
          pattern12: '{day}/{month}/{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'G',
              'F',
              'M',
              'A',
              'M',
              'G',
              'L',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'gen',
              'feb',
              'mar',
              'apr',
              'mag',
              'giu',
              'lug',
              'ago',
              'set',
              'ott',
              'nov',
              'dic',
            ],
            long: [
              'gennaio',
              'febbraio',
              'marzo',
              'aprile',
              'maggio',
              'giugno',
              'luglio',
              'agosto',
              'settembre',
              'ottobre',
              'novembre',
              'dicembre',
            ],
          },
          'months-stand-alone': {
            long: [
              'Gennaio',
              'Febbraio',
              'Marzo',
              'Aprile',
              'Maggio',
              'Giugno',
              'Luglio',
              'Agosto',
              'Settembre',
              'Ottobre',
              'Novembre',
              'Dicembre',
            ],
          },
          days: {
            narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
            short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
            long: [
              'domenica',
              'lunedì',
              'martedì',
              'mercoledì',
              'giovedì',
              'venerdì',
              'sabato',
            ],
          },
          eras: {
            narrow: ['aC', 'dC', 'BCE', 'CE'],
            short: ['aC', 'dC', 'BCE', 'CE'],
            long: ['a.C.', 'd.C.', 'BCE', 'CE'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'A$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        ILS: '₪',
        INR: '₹',
        NZD: 'NZ$',
        THB: '฿',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'ja',
    date: {
      ca: ['gregory'],
      hourNo0: !1,
      hour12: !1,
      formats: [
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern:
            '{year}年{month}月{day}日({weekday}) {hour}:{minute}:{second}',
          pattern12:
            '{year}年{month}月{day}日({weekday}) {ampm}{hour}:{minute}:{second}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          pattern: '{year}年{month}月{day}日({weekday})',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}/{month}/{day}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          pattern: '{year}/{month}/{day}',
        },
        { year: 'numeric', month: 'long', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'short', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'numeric', pattern: '{year}/{month}' },
        { month: 'long', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'short', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'numeric', day: 'numeric', pattern: '{month}/{day}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{ampm}{hour}:{minute}:{second}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{ampm}{hour}:{minute}',
        },
        { year: 'numeric', pattern: '{year}年' },
        { year: '2-digit', pattern: '{year}年' },
        { month: 'long', pattern: '{month}月' },
        { month: 'short', pattern: '{month}月' },
        { month: 'numeric', pattern: '{month}月' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}日' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
            ],
            short: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            long: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
          },
          days: {
            narrow: ['日', '月', '火', '水', '木', '金', '土'],
            short: ['日', '月', '火', '水', '木', '金', '土'],
            long: [
              '日曜日',
              '月曜日',
              '火曜日',
              '水曜日',
              '木曜日',
              '金曜日',
              '土曜日',
            ],
          },
          eras: {
            narrow: ['BC', 'AD', 'BCE', 'CE'],
            short: ['紀元前', '西暦', '西暦紀元前', '西暦紀元'],
            long: ['紀元前', '西暦', '西暦紀元前', '西暦紀元'],
          },
          dayPeriods: { am: '午前', pm: '午後' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: '元',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '￥',
        KRW: '￦',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'ko',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern:
            '{year}년 {month} {day}일 ({weekday})  {hour}:{minute}:{second}',
          pattern12:
            '{year}년 {month} {day}일 ({weekday}) {ampm} {hour}:{minute}:{second}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          pattern: '{year}년 {month} {day}일 ({weekday})',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}년 {month} {day}일  {hour}:{minute}',
          pattern12: '{year}년 {month} {day}일 {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}년 {month} {day}일  {hour}:{minute}',
          pattern12: '{year}년 {month} {day}일 {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}년 {month} {day}일  {hour}:{minute}',
          pattern12: '{year}년 {month} {day}일 {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}년 {month} {day}일  {hour}:{minute}',
          pattern12: '{year}년 {month} {day}일 {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}. {month}. {day}.  {hour}:{minute}',
          pattern12: '{year}. {month}. {day}. {ampm} {hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          pattern: '{year}년 {month} {day}일',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          pattern: '{year}년 {month} {day}일',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}. {month}. {day}.',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          pattern: '{year}. {month}. {day}.',
        },
        { year: 'numeric', month: 'long', pattern: '{year}년 {month}' },
        { year: 'numeric', month: 'short', pattern: '{year}년 {month}' },
        { year: 'numeric', month: 'numeric', pattern: '{year}. {month}.' },
        { month: 'long', day: 'numeric', pattern: '{month} {day}일' },
        { month: 'short', day: 'numeric', pattern: '{month} {day}일' },
        { month: 'numeric', day: 'numeric', pattern: '{month}. {day}.' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{ampm} {hour}:{minute}:{second}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{ampm} {hour}:{minute}',
        },
        { year: 'numeric', pattern: '{year}년' },
        { year: '2-digit', pattern: '{year}년' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}월' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}일' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              '1월',
              '2월',
              '3월',
              '4월',
              '5월',
              '6월',
              '7월',
              '8월',
              '9월',
              '10월',
              '11월',
              '12월',
            ],
            short: [
              '1월',
              '2월',
              '3월',
              '4월',
              '5월',
              '6월',
              '7월',
              '8월',
              '9월',
              '10월',
              '11월',
              '12월',
            ],
            long: [
              '1월',
              '2월',
              '3월',
              '4월',
              '5월',
              '6월',
              '7월',
              '8월',
              '9월',
              '10월',
              '11월',
              '12월',
            ],
          },
          days: {
            narrow: ['일', '월', '화', '수', '목', '금', '토'],
            short: ['일', '월', '화', '수', '목', '금', '토'],
            long: [
              '일요일',
              '월요일',
              '화요일',
              '수요일',
              '목요일',
              '금요일',
              '토요일',
            ],
          },
          eras: {
            short: ['기원전', '서기', 'BCE', 'CE'],
            long: ['기원전', '서기'],
          },
          dayPeriods: { am: '오전', pm: '오후' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'ms',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {day} {month} {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} {month} {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}-{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}-{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'O',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'Jan',
              'Feb',
              'Mac',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Ogo',
              'Sep',
              'Okt',
              'Nov',
              'Dis',
            ],
            long: [
              'Januari',
              'Februari',
              'Mac',
              'April',
              'Mei',
              'Jun',
              'Julai',
              'Ogos',
              'September',
              'Oktober',
              'November',
              'Disember',
            ],
          },
          days: {
            narrow: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
            short: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
            long: [
              'Ahad',
              'Isnin',
              'Selasa',
              'Rabu',
              'Khamis',
              'Jumaat',
              'Sabtu',
            ],
          },
          eras: { short: ['S.M.', 'TM'], long: ['S.M.', 'TM'] },
          dayPeriods: { am: 'PG', pm: 'PTG' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'A$',
        BRL: 'R$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '₩',
        MYR: 'RM',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'nl',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day} {month} {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day} {month} {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}-{month}-{year} {hour}:{minute}',
          pattern12: '{day}-{month}-{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}-{month}-{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}-{month}-{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}-{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}-{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'jan.',
              'feb.',
              'mrt.',
              'apr.',
              'mei',
              'jun.',
              'jul.',
              'aug.',
              'sep.',
              'okt.',
              'nov.',
              'dec.',
            ],
            long: [
              'januari',
              'februari',
              'maart',
              'april',
              'mei',
              'juni',
              'juli',
              'augustus',
              'september',
              'oktober',
              'november',
              'december',
            ],
          },
          'months-stand-alone': {
            short: [
              'Jan.',
              'Feb.',
              'Mrt.',
              'Apr.',
              'Mei',
              'Jun.',
              'Jul.',
              'Aug.',
              'Sep.',
              'Okt.',
              'Nov.',
              'Dec.',
            ],
            long: [
              'Januari',
              'Februari',
              'Maart',
              'April',
              'Mei',
              'Juni',
              'Juli',
              'Augustus',
              'September',
              'Oktober',
              'November',
              'December',
            ],
          },
          days: {
            narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
            short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            long: [
              'zondag',
              'maandag',
              'dinsdag',
              'woensdag',
              'donderdag',
              'vrijdag',
              'zaterdag',
            ],
          },
          eras: {
            narrow: ['v.C.', 'n.C.', 'vgj', 'gj'],
            short: ['v.Chr.', 'n.Chr.', 'v.g.j.', 'g.j.'],
            long: [
              'voor Christus',
              'na Christus',
              'vóór gewone jaartelling',
              'gewone jaartelling',
            ],
          },
          dayPeriods: { am: 'a.m.', pm: 'p.m.' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency} {number}',
          negativePattern: '{currency} {number}-',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'C$',
        CNY: 'CN¥',
        EUR: '€',
        FJD: 'FJ$',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        SBD: 'SI$',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'nb',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day}. {month} {year}, {hour}.{minute}.{second}',
          pattern12:
            '{weekday} {day}. {month} {year}, {hour}.{minute}.{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}.{minute}',
          pattern12: '{day}. {month} {year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}.{minute}',
          pattern12: '{day}. {month} {year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}.{minute}',
          pattern12: '{day}. {month} {year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}. {month} {year}, {hour}.{minute}',
          pattern12: '{day}. {month} {year}, {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}.{minute}',
          pattern12: '{day}.{month}.{year}, {hour}.{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day}. {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}.{year}' },
        { day: 'numeric', month: 'long', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'short', pattern: '{day}. {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}.{month}.' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}.{minute}.{second}',
          pattern12: '{hour}.{minute}.{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}.{minute}',
          pattern12: '{hour}.{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}.' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}.' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'jan.',
              'feb.',
              'mar.',
              'apr.',
              'mai',
              'jun.',
              'jul.',
              'aug.',
              'sep.',
              'okt.',
              'nov.',
              'des.',
            ],
            long: [
              'januar',
              'februar',
              'mars',
              'april',
              'mai',
              'juni',
              'juli',
              'august',
              'september',
              'oktober',
              'november',
              'desember',
            ],
          },
          'months-stand-alone': {
            short: [
              'jan',
              'feb',
              'mar',
              'apr',
              'mai',
              'jun',
              'jul',
              'aug',
              'sep',
              'okt',
              'nov',
              'des',
            ],
          },
          days: {
            narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
            short: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
            long: [
              'søndag',
              'mandag',
              'tirsdag',
              'onsdag',
              'torsdag',
              'fredag',
              'lørdag',
            ],
          },
          eras: {
            narrow: ['f.Kr.', 'e.Kr.', 'fvt.', 'vt'],
            short: ['f.Kr.', 'e.Kr.', 'fvt.', 'vt.'],
            long: ['f.Kr.', 'e.Kr.', 'før vår tidsregning', 'vår tidsregning'],
          },
          dayPeriods: { am: 'a.m.', pm: 'p.m.' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency} {number}',
          negativePattern: '-{currency} {number}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: { EUR: '€', GBP: '£', NOK: 'kr', XOF: 'CFA' },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'pl',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {day} {month} {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} {month} {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: '2-digit',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: 'numeric',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: '2-digit', year: 'numeric', pattern: '{month}.{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: '2-digit', pattern: '{day}.{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              's',
              'l',
              'm',
              'k',
              'm',
              'c',
              'l',
              's',
              'w',
              'p',
              'l',
              'g',
            ],
            short: [
              'sty',
              'lut',
              'mar',
              'kwi',
              'maj',
              'cze',
              'lip',
              'sie',
              'wrz',
              'paź',
              'lis',
              'gru',
            ],
            long: [
              'stycznia',
              'lutego',
              'marca',
              'kwietnia',
              'maja',
              'czerwca',
              'lipca',
              'sierpnia',
              'września',
              'października',
              'listopada',
              'grudnia',
            ],
          },
          'months-stand-alone': {
            long: [
              'styczeń',
              'luty',
              'marzec',
              'kwiecień',
              'maj',
              'czerwiec',
              'lipiec',
              'sierpień',
              'wrzesień',
              'październik',
              'listopad',
              'grudzień',
            ],
          },
          days: {
            narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
            short: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
            long: [
              'niedziela',
              'poniedziałek',
              'wtorek',
              'środa',
              'czwartek',
              'piątek',
              'sobota',
            ],
          },
          eras: {
            short: ['p.n.e.', 'n.e.', 'BCE', 'CE'],
            long: ['p.n.e.', 'n.e.', 'BCE', 'CE'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        BRL: 'R$',
        EUR: '€',
        PLN: 'zł',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'pt',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern:
            '{weekday}, {day} de {month} de {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} de {month} de {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} de {month} de {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} de {month} de {year} {hour}:{minute}',
          pattern12: '{day} de {month} de {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} de {month} de {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} de {month} de {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} de {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} de {year}' },
        { month: '2-digit', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} de {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} de {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'jan',
              'fev',
              'mar',
              'abr',
              'mai',
              'jun',
              'jul',
              'ago',
              'set',
              'out',
              'nov',
              'dez',
            ],
            long: [
              'janeiro',
              'fevereiro',
              'março',
              'abril',
              'maio',
              'junho',
              'julho',
              'agosto',
              'setembro',
              'outubro',
              'novembro',
              'dezembro',
            ],
          },
          days: {
            narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
            long: [
              'domingo',
              'segunda-feira',
              'terça-feira',
              'quarta-feira',
              'quinta-feira',
              'sexta-feira',
              'sábado',
            ],
          },
          eras: {
            short: ['a.C.', 'd.C.', 'AEC', 'EC'],
            long: [
              'Antes de Cristo',
              'Ano do Senhor',
              'Antes da Era Comum',
              'Era Comum',
            ],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        PTE: 'Esc.',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'ro',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {day} {month} {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} {month} {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}, {hour}:{minute}',
          pattern12: '{day} {month} {year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: '2-digit', year: 'numeric', pattern: '{month}.{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: '2-digit', month: '2-digit', pattern: '{day}.{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'I',
              'F',
              'M',
              'A',
              'M',
              'I',
              'I',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'ian.',
              'feb.',
              'mar.',
              'apr.',
              'mai',
              'iun.',
              'iul.',
              'aug.',
              'sept.',
              'oct.',
              'nov.',
              'dec.',
            ],
            long: [
              'ianuarie',
              'februarie',
              'martie',
              'aprilie',
              'mai',
              'iunie',
              'iulie',
              'august',
              'septembrie',
              'octombrie',
              'noiembrie',
              'decembrie',
            ],
          },
          'months-stand-alone': {
            long: [
              'Ianuarie',
              'Februarie',
              'Martie',
              'Aprilie',
              'Mai',
              'Iunie',
              'Iulie',
              'August',
              'Septembrie',
              'Octombrie',
              'Noiembrie',
              'Decembrie',
            ],
          },
          days: {
            narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
            short: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
            long: [
              'duminică',
              'luni',
              'marți',
              'miercuri',
              'joi',
              'vineri',
              'sâmbătă',
            ],
          },
          eras: {
            short: ['î.Hr.', 'd.Hr.', 'î.e.n', 'e.n.'],
            long: [
              'înainte de Hristos',
              'după Hristos',
              'înaintea erei noastre',
              'era noastră',
            ],
          },
          dayPeriods: { am: 'a.m.', pm: 'p.m.' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: { XAF: 'FCFA', XOF: 'CFA', XPF: 'CFPF' },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'ru',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern:
            '{weekday}, {day} {month} {year} г., {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {day} {month} {year} г., {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday}, {day} {month} {year} г.',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} г., {hour}:{minute}',
          pattern12: '{day} {month} {year} г., {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} г., {hour}:{minute}',
          pattern12: '{day} {month} {year} г., {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} г., {hour}:{minute}',
          pattern12: '{day} {month} {year} г., {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} г., {hour}:{minute}',
          pattern12: '{day} {month} {year} г., {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}, {hour}:{minute}',
          pattern12: '{day}.{month}.{year}, {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year} г.',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year} г.',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: '2-digit', year: 'numeric', pattern: '{month}.{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: '2-digit', month: '2-digit', pattern: '{day}.{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'Я',
              'Ф',
              'М',
              'А',
              'М',
              'И',
              'И',
              'А',
              'С',
              'О',
              'Н',
              'Д',
            ],
            short: [
              'янв.',
              'февр.',
              'марта',
              'апр.',
              'мая',
              'июня',
              'июля',
              'авг.',
              'сент.',
              'окт.',
              'нояб.',
              'дек.',
            ],
            long: [
              'января',
              'февраля',
              'марта',
              'апреля',
              'мая',
              'июня',
              'июля',
              'августа',
              'сентября',
              'октября',
              'ноября',
              'декабря',
            ],
          },
          'months-stand-alone': {
            short: [
              'янв.',
              'февр.',
              'март',
              'апр.',
              'май',
              'июнь',
              'июль',
              'авг.',
              'сент.',
              'окт.',
              'нояб.',
              'дек.',
            ],
            long: [
              'январь',
              'февраль',
              'март',
              'апрель',
              'май',
              'июнь',
              'июль',
              'август',
              'сентябрь',
              'октябрь',
              'ноябрь',
              'декабрь',
            ],
          },
          days: {
            narrow: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
            short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
            long: [
              'воскресенье',
              'понедельник',
              'вторник',
              'среда',
              'четверг',
              'пятница',
              'суббота',
            ],
          },
          eras: {
            narrow: ['до н.э.', 'н.э.'],
            short: ['до н. э.', 'н. э.'],
            long: ['до н. э.', 'н. э.'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: 'не число',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'A$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        RUB: 'руб.',
        RUR: 'р.',
        THB: '฿',
        TMT: 'ТМТ',
        TWD: 'NT$',
        UAH: '₴',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
        XXX: 'XXXX',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'sv',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day} {month} {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day} {month} {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}-{month}-{day} {hour}:{minute}',
          pattern12: '{year}-{month}-{day} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}-{month}-{day}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}-{month}-{day}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { year: 'numeric', month: '2-digit', pattern: '{year}-{month}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'J',
              'F',
              'M',
              'A',
              'M',
              'J',
              'J',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'jan.',
              'feb.',
              'mars',
              'apr.',
              'maj',
              'juni',
              'juli',
              'aug.',
              'sep.',
              'okt.',
              'nov.',
              'dec.',
            ],
            long: [
              'januari',
              'februari',
              'mars',
              'april',
              'maj',
              'juni',
              'juli',
              'augusti',
              'september',
              'oktober',
              'november',
              'december',
            ],
          },
          'months-stand-alone': {
            short: [
              'Jan.',
              'Feb.',
              'Mars',
              'Apr.',
              'Maj',
              'Juni',
              'Juli',
              'Aug.',
              'Sep.',
              'Okt.',
              'Nov.',
              'Dec.',
            ],
            long: [
              'Januari',
              'Februari',
              'Mars',
              'April',
              'Maj',
              'Juni',
              'Juli',
              'Augusti',
              'September',
              'Oktober',
              'November',
              'December',
            ],
          },
          days: {
            narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
            short: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
            long: [
              'söndag',
              'måndag',
              'tisdag',
              'onsdag',
              'torsdag',
              'fredag',
              'lördag',
            ],
          },
          eras: {
            narrow: ['f.Kr.', 'e.Kr.', 'fvt', 'vt'],
            short: ['f.Kr.', 'e.Kr.', 'f.v.t.', 'v.t.'],
            long: [
              'före Kristus',
              'efter Kristus',
              'före västerländsk tideräkning',
              'västerländsk tideräkning',
            ],
          },
          dayPeriods: { am: 'fm', pm: 'em' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '{number} %',
          negativePattern: '-{number} %',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: ' ',
          nan: '¤¤¤',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        BBD: 'Bds$',
        BMD: 'BM$',
        BRL: 'BR$',
        BSD: 'BS$',
        BZD: 'BZ$',
        CAD: 'CAN$',
        DKK: 'Dkr',
        DOP: 'RD$',
        EEK: 'Ekr',
        EGP: 'EG£',
        EUR: '€',
        ILS: '₪',
        ISK: 'Ikr',
        JMD: 'JM$',
        MXN: 'MX$',
        NOK: 'Nkr',
        SEK: 'kr',
        USD: 'US$',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'th',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday} {day} {month} {year} {hour}:{minute}:{second}',
          pattern12:
            '{weekday} {day} {month} {year} {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{weekday} {day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year} {hour}:{minute}',
          pattern12: '{day} {month} {year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}/{month}/{year} {hour}:{minute}',
          pattern12: '{day}/{month}/{year} {hour}:{minute} {ampm}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          pattern: '{day}/{month}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { day: 'numeric', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: 'numeric', month: 'numeric', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'ม.ค.',
              'ก.พ.',
              'มี.ค.',
              'เม.ย.',
              'พ.ค.',
              'มิ.ย.',
              'ก.ค.',
              'ส.ค.',
              'ก.ย.',
              'ต.ค.',
              'พ.ย.',
              'ธ.ค.',
            ],
            short: [
              'ม.ค.',
              'ก.พ.',
              'มี.ค.',
              'เม.ย.',
              'พ.ค.',
              'มิ.ย.',
              'ก.ค.',
              'ส.ค.',
              'ก.ย.',
              'ต.ค.',
              'พ.ย.',
              'ธ.ค.',
            ],
            long: [
              'มกราคม',
              'กุมภาพันธ์',
              'มีนาคม',
              'เมษายน',
              'พฤษภาคม',
              'มิถุนายน',
              'กรกฎาคม',
              'สิงหาคม',
              'กันยายน',
              'ตุลาคม',
              'พฤศจิกายน',
              'ธันวาคม',
            ],
          },
          days: {
            narrow: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
            short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
            long: [
              'วันอาทิตย์',
              'วันจันทร์',
              'วันอังคาร',
              'วันพุธ',
              'วันพฤหัสบดี',
              'วันศุกร์',
              'วันเสาร์',
            ],
          },
          eras: {
            narrow: ['ก่อน ค.ศ.', 'ค.ศ.', 'ก.ส.ศ.', 'ส.ศ.'],
            short: ['ปีก่อน ค.ศ.', 'ค.ศ.', 'ก.ส.ศ.', 'ส.ศ.'],
            long: [
              'ปีก่อนคริสต์ศักราช',
              'คริสต์ศักราช',
              'ก่อนสามัญศักราช',
              'สามัญศักราช',
            ],
          },
          dayPeriods: { am: 'ก่อนเที่ยง', pm: 'หลังเที่ยง' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'fil',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{weekday}, {month} {day}, {year}, {hour}:{minute}:{second}',
          pattern12:
            '{weekday}, {month} {day}, {year}, {hour}:{minute}:{second} {ampm}',
        },
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          pattern: '{weekday}, {month} {day}, {year}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month} {day}, {year}, {hour}:{minute}',
          pattern12: '{month} {day}, {year}, {hour}:{minute} {ampm}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{month}/{day}/{year}, {hour}:{minute}',
          pattern12: '{month}/{day}/{year}, {hour}:{minute} {ampm}',
        },
        {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month} {day}, {year}',
        },
        {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month} {day}, {year}',
        },
        {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          pattern: '{month}/{day}/{year}',
        },
        {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          pattern: '{month}/{day}/{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: 'numeric', year: 'numeric', pattern: '{month}/{year}' },
        { month: 'long', day: 'numeric', pattern: '{month} {day}' },
        { month: 'short', day: 'numeric', pattern: '{month} {day}' },
        { month: 'numeric', day: 'numeric', pattern: '{month}/{day}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{hour}:{minute}:{second} {ampm}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{hour}:{minute} {ampm}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'E',
              'P',
              'M',
              'A',
              'M',
              'H',
              'H',
              'A',
              'S',
              'O',
              'N',
              'D',
            ],
            short: [
              'Ene',
              'Peb',
              'Mar',
              'Abr',
              'May',
              'Hun',
              'Hul',
              'Ago',
              'Set',
              'Okt',
              'Nob',
              'Dis',
            ],
            long: [
              'Enero',
              'Pebrero',
              'Marso',
              'Abril',
              'Mayo',
              'Hunyo',
              'Hulyo',
              'Agosto',
              'Setyembre',
              'Oktubre',
              'Nobyembre',
              'Disyembre',
            ],
          },
          days: {
            narrow: ['L', 'L', 'M', 'M', 'H', 'B', 'S'],
            short: ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
            long: [
              'Linggo',
              'Lunes',
              'Martes',
              'Miyerkules',
              'Huwebes',
              'Biyernes',
              'Sabado',
            ],
          },
          eras: {
            short: ['BC', 'AD', 'BCE', 'CE'],
            long: ['BC', 'AD', 'BCE', 'CE'],
          },
          dayPeriods: { am: 'AM', pm: 'PM' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency}{number}',
          negativePattern: '-{currency}{number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'A$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        PHP: '₱',
        THB: '฿',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'tr',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !1,
      formats: [
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{day} {month} {year} {weekday}  {hour}:{minute}:{second}',
          pattern12:
            '{day} {month} {year} {weekday} {ampm} {hour}:{minute}:{second}',
        },
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          weekday: 'long',
          pattern: '{day} {month} {year} {weekday}',
        },
        {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}  {hour}:{minute}',
          pattern12: '{day} {month} {year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}  {hour}:{minute}',
          pattern12: '{day} {month} {year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day} {month} {year}  {hour}:{minute}',
          pattern12: '{day} {month} {year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day} {month} {year}  {hour}:{minute}',
          pattern12: '{day} {month} {year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{day}.{month}.{year}  {hour}:{minute}',
          pattern12: '{day}.{month}.{year} {ampm} {hour}:{minute}',
        },
        {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          pattern: '{day} {month} {year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          pattern: '{day}.{month}.{year}',
        },
        { month: 'long', year: 'numeric', pattern: '{month} {year}' },
        { month: 'short', year: 'numeric', pattern: '{month} {year}' },
        { month: '2-digit', year: 'numeric', pattern: '{month}/{year}' },
        { day: '2-digit', month: 'long', pattern: '{day} {month}' },
        { day: 'numeric', month: 'short', pattern: '{day} {month}' },
        { day: '2-digit', month: '2-digit', pattern: '{day}/{month}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{ampm} {hour}:{minute}:{second}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{ampm} {hour}:{minute}',
        },
        { year: 'numeric', pattern: '{year}' },
        { year: '2-digit', pattern: '{year}' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              'O',
              'Ş',
              'M',
              'N',
              'M',
              'H',
              'T',
              'A',
              'E',
              'E',
              'K',
              'A',
            ],
            short: [
              'Oca',
              'Şub',
              'Mar',
              'Nis',
              'May',
              'Haz',
              'Tem',
              'Ağu',
              'Eyl',
              'Eki',
              'Kas',
              'Ara',
            ],
            long: [
              'Ocak',
              'Şubat',
              'Mart',
              'Nisan',
              'Mayıs',
              'Haziran',
              'Temmuz',
              'Ağustos',
              'Eylül',
              'Ekim',
              'Kasım',
              'Aralık',
            ],
          },
          days: {
            narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
            short: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
            long: [
              'Pazar',
              'Pazartesi',
              'Salı',
              'Çarşamba',
              'Perşembe',
              'Cuma',
              'Cumartesi',
            ],
          },
          eras: {
            short: ['MÖ', 'MS', 'İÖ', 'İS'],
            long: [
              'Milattan Önce',
              'Milattan Sonra',
              'İsa’dan Önce',
              'İsa’dan Sonra',
            ],
          },
          dayPeriods: { am: 'ÖÖ', pm: 'ÖS' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{number} {currency}',
          negativePattern: '-{number} {currency}',
        },
        percent: {
          positivePattern: '%{number}',
          negativePattern: '-%{number}',
        },
      },
      symbols: {
        latn: {
          decimal: ',',
          group: '.',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: 'CN¥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILS: '₪',
        INR: '₹',
        JPY: '¥',
        KRW: '₩',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TRY: '₺',
        TWD: 'NT$',
        USD: '$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'zh',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{year}年{month}月{day}日{weekday} {hour}:{minute}:{second}',
          pattern12:
            '{year}年{month}月{day}日{weekday} {ampm}{hour}:{minute}:{second}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          pattern: '{year}年{month}月{day}日{weekday}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}/{month}/{day}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          pattern: '{year}/{month}/{day}',
        },
        { year: 'numeric', month: 'long', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'short', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'numeric', pattern: '{year}年{month}月' },
        { month: 'long', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'short', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'numeric', day: 'numeric', pattern: '{month}/{day}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{ampm}{hour}:{minute}:{second}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{ampm}{hour}:{minute}',
        },
        { year: 'numeric', pattern: '{year}年' },
        { year: '2-digit', pattern: '{year}年' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}月' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}日' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
            ],
            short: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            long: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
          },
          days: {
            narrow: ['日', '一', '二', '三', '四', '五', '六'],
            short: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            long: [
              '星期日',
              '星期一',
              '星期二',
              '星期三',
              '星期四',
              '星期五',
              '星期六',
            ],
          },
          eras: {
            narrow: ['公元前', '公元'],
            short: ['公元前', '公元'],
            long: ['公元前', '公元'],
          },
          dayPeriods: { am: '上午', pm: '下午' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency} {number}',
          negativePattern: '-{currency} {number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: '￥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILR: 'ILS',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '￦',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  }),
  IntlPolyfill.__addLocaleData({
    locale: 'zh',
    date: {
      ca: ['gregory'],
      hourNo0: !0,
      hour12: !0,
      formats: [
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{year}年{month}月{day}日{weekday} {hour}:{minute}:{second}',
          pattern12:
            '{year}年{month}月{day}日{weekday} {ampm}{hour}:{minute}:{second}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          weekday: 'long',
          pattern: '{year}年{month}月{day}日{weekday}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}年{month}月{day}日 {hour}:{minute}',
          pattern12: '{year}年{month}月{day}日 {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{year}/{month}/{day} {hour}:{minute}',
          pattern12: '{year}/{month}/{day} {ampm}{hour}:{minute}',
        },
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          pattern: '{year}年{month}月{day}日',
        },
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          pattern: '{year}/{month}/{day}',
        },
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          pattern: '{year}/{month}/{day}',
        },
        { year: 'numeric', month: 'long', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'short', pattern: '{year}年{month}月' },
        { year: 'numeric', month: 'numeric', pattern: '{year}年{month}月' },
        { month: 'long', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'short', day: 'numeric', pattern: '{month}月{day}日' },
        { month: 'numeric', day: 'numeric', pattern: '{month}/{day}' },
        {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          pattern: '{hour}:{minute}:{second}',
          pattern12: '{ampm}{hour}:{minute}:{second}',
        },
        {
          hour: 'numeric',
          minute: '2-digit',
          pattern: '{hour}:{minute}',
          pattern12: '{ampm}{hour}:{minute}',
        },
        { year: 'numeric', pattern: '{year}年' },
        { year: '2-digit', pattern: '{year}年' },
        { month: 'long', pattern: '{month}' },
        { month: 'short', pattern: '{month}' },
        { month: 'numeric', pattern: '{month}月' },
        { weekday: 'long', pattern: '{weekday}' },
        { weekday: 'narrow', pattern: '{weekday}' },
        { weekday: 'short', pattern: '{weekday}' },
        { day: 'numeric', pattern: '{day}日' },
      ],
      calendars: {
        gregory: {
          months: {
            narrow: [
              '1',
              '2',
              '3',
              '4',
              '5',
              '6',
              '7',
              '8',
              '9',
              '10',
              '11',
              '12',
            ],
            short: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            long: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
          },
          days: {
            narrow: ['日', '一', '二', '三', '四', '五', '六'],
            short: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            long: [
              '星期日',
              '星期一',
              '星期二',
              '星期三',
              '星期四',
              '星期五',
              '星期六',
            ],
          },
          eras: {
            narrow: ['公元前', '公元'],
            short: ['公元前', '公元'],
            long: ['公元前', '公元'],
          },
          dayPeriods: { am: '上午', pm: '下午' },
        },
      },
    },
    number: {
      nu: ['latn'],
      patterns: {
        decimal: { positivePattern: '{number}', negativePattern: '-{number}' },
        currency: {
          positivePattern: '{currency} {number}',
          negativePattern: '-{currency} {number}',
        },
        percent: {
          positivePattern: '{number}%',
          negativePattern: '-{number}%',
        },
      },
      symbols: {
        latn: {
          decimal: '.',
          group: ',',
          nan: 'NaN',
          percent: '%',
          infinity: '∞',
        },
      },
      currencies: {
        AUD: 'AU$',
        BRL: 'R$',
        CAD: 'CA$',
        CNY: '￥',
        EUR: '€',
        GBP: '£',
        HKD: 'HK$',
        ILR: 'ILS',
        ILS: '₪',
        INR: '₹',
        JPY: 'JP¥',
        KRW: '￦',
        MXN: 'MX$',
        NZD: 'NZ$',
        THB: '฿',
        TWD: 'NT$',
        USD: 'US$',
        VND: '₫',
        XAF: 'FCFA',
        XCD: 'EC$',
        XOF: 'CFA',
        XPF: 'CFPF',
      },
    },
  });
